module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id=\'utilities-accordion\'></div>\n<div id="electricity_costs_container"></div>\n<div id="gas_energy_costs_container"></div>\n<div id="gas_volume_costs_container"></div>\n<div id="water_costs_container"></div>\n<div id="hot_water_energy_costs_container"></div>\n<div id="cooled_water_energy_costs_container"></div>\n<div id="oil_costs_container"></div>\n';

}
return __p
}